module.exports = __webpack_public_path__ + "static/media/Kean Walmsley.ef2b8aaf.png";